import React from 'react'
import { shallow } from 'enzyme'
import LoanRow from '../LoanRow'
import SmartRateDisplay from '../../smartrate/SmartRateDisplay'

describe('<LoanRow />', () => {
  let wrapper, instance, props
  beforeEach(() => {
    props = {
      loan: {
        id: 1,
        app_number: 1,
        notifications: [],
        priority: 1,
        company_name: 'test biz',
        borrower_id: 2,
        borrower_name: 'test borrower',
        enable_advisor: false,
        amount_format: '100,000',
        smart_rate: 4,
        partner_name: 'test partner',
        lender_name: 'test lender',
        state: 'funded',
        audit_handed_off_at: 2393939344,
        days_since_assigned: 10,
        active_items: [],
        showActivity: false,
        activeTab: 'audit'
      },
      smartRateDisplayProps: {
        defaultProbability: 0.2,
        dataPermutation: 'credit',
        needsRedecision: false,
        productUsesDefaultModel: true
      },
      enableEdit: false,
      customerService: true,
      isPPP: true,
      csrfToken: 'asdf',
      updateLoanState: () => {}
    }
    wrapper = shallow(<LoanRow {...props} />)
    instance = wrapper.instance()
  })
  describe('when the user has the customer service role', () => {
    beforeEach(() => {
      wrapper.setState({ customerService: true }) // Pipeline stores its props in state. RIP
    })
    it('should render a <SmartRateDisplay />', () => {
      expect(wrapper.find(SmartRateDisplay)).toHaveLength(1)
    })
  })
  describe('when the user does not have the customer service role', () => {
    beforeEach(() => {
      wrapper.setState({ customerService: false })
    })
    it('should not render a <SmartRateDisplay />', () => {
      expect(wrapper.find(SmartRateDisplay)).toHaveLength(0)
    })
  })
})
